import React from 'react';
import { Grid, Typography, CardContent } from '@mui/material';
import { StyledCard, ImageWithPreview } from './shared';
import { getHTTPUrlFromS3Path } from '../../../utils/outputs';

interface Detection {
  label: string;
  image: string;
  caption: string;
  bbox: any;
}

interface DetectionsSectionProps {
  detections: Detection[];
}

const DetectionsSection: React.FC<DetectionsSectionProps> = ({ detections }) => {
  if (!detections?.length) return null;
  return (
    <Grid item xs={12}>
      <Typography variant="h2" sx={{ mb: 2 }}>Detections</Typography>
      <Grid container spacing={2}>
        {detections.map((detection, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <StyledCard>
              <ImageWithPreview
                src={(url => url.endsWith('/') ? url.slice(0, -1) : url)(getHTTPUrlFromS3Path(detection.image))}
                alt={detection.caption}
                identifier={`detection-${index}`}
              />
              <CardContent sx={{ backgroundColor: '#1111' }}>
                <Typography variant="h6">{detection.label}</Typography>
                <Typography>{detection.caption}</Typography>
              </CardContent>
            </StyledCard>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

export default DetectionsSection;
